module.exports = __webpack_public_path__ + "img/3_2.a485a113.png";